import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { PaymentType } from "@/helpers/types/types.ts";
import { parsePaymentResult } from "@/pages/AccommodationPicking/hooks/parsePaymentResult.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { AppPage } from "@/stores/EngineStore/enums/AppPage.ts";
import { PaymentResultType } from "@/stores/EngineStore/enums/PaymentResultType.ts";
import { useLayoutEffect } from "react";
import { useShallow } from "zustand/react/shallow";

export const usePaymentResultURLParam = () => {
  const { setPaymentResult, page, setPage, resetAll } = useEngineStore(
    useShallow((state) => ({
      setPaymentResult: state.setPaymentResult,
      page: state.page,
      setPage: state.setPage,
      resetAll: state.resetAll,
    })),
  );

  // useLayoutEffect for better recognisition
  useLayoutEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const rawPaymentResult = urlParams.get(URLParam.PaymentResult);

    if (!rawPaymentResult) {
      if (page === AppPage.PaymentResult) setPage(AppPage.AccommodationPicking, "replace");
      return;
    }

    // Unrecognised values are treated as a failed payment rather than silently ignored
    const paymentResultType = parsePaymentResult(rawPaymentResult) ?? PaymentResultType.Error;

    // Decided before the reset below clears the cart; the persisted flag covers a reload of the result page
    const { calculatedCartData, isCardGuaranteeResult } = useEngineStore.getState();
    const isCardGuarantee = calculatedCartData
      ? calculatedCartData.paymentConfig?.paymentType === PaymentType.CardGuarantee
      : isCardGuaranteeResult;

    // On cancellation or error the cart is preserved so the user can retry from the result page
    if (paymentResultType === PaymentResultType.Success) resetAll(true);
    setPaymentResult(paymentResultType, isCardGuarantee);

    // eslint-disable-next-line
  }, [window.location.search]);
};
